import React, { Component } from 'react'
import { Icon, Button } from 'react-materialize'
import MapView from './MapView'
import domtoimage from 'dom-to-image'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'




class MapViewCollapsible extends Component {
  constructor(props) {
   super(props)
   this.state = {
     collapsible: true,
     mapSize: 1,
     clickTimes: 1
   }
 }

 onClickCollapsible(){
   let temp = this.state.collapsible;

   let clickTimes = temp === false? this.state.clickTimes + 1: this.state.clickTimes
   this.setState({ collapsible: !temp, clickTimes })
 }

 componentWillReceiveProps(nextProps){
   var rthis = this;
   this.setState({ collapsible: false})
   setTimeout(this.setState({ collapsible: true}), 2000);
 }


 downloadJPG(){
   var node = document.getElementById('map-views');
   domtoimage.toJpeg(document.getElementById('bar-chart'), { bgcolor: "white", height: 600, width: 1100 })
    .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = 'bar_chart.jpeg';
        link.href = dataUrl;
        link.click();
    });
 }

 increaseMap(){
   var mapSize = this.state.mapSize
   mapSize = mapSize <= 5 ? mapSize += 1: mapSize
   this.setState({ mapSize })
 }

 decreaseMap(){
   var mapSize = this.state.mapSize
   mapSize = mapSize>= 1 ? mapSize -= 1: mapSize
   this.setState({ mapSize })
 }



render() {
  const { message } = this.state;
  const { gender, countries, age } = this.props
  return (
    <div className="map-view-collapsible">
      <div className="map-view-collapsible-title" onClick={() => this.onClickCollapsible()}>
        <div className="view-text">
          <span style={{display: 'flex', alignItems: "center"}}>
            Map
          </span>
          <span className="message">
              Select one gender, one age, and either “All Countries” or up to 10 individual countries to view map.
              <br/>Note: Data displayed pertain to the most recent year available for each country.
          </span>
        </div>
        <div className="view-icon">

          {
              this.state.collapsible? <Icon>keyboard_arrow_up</Icon>:<Icon>keyboard_arrow_down</Icon>
          }
        </div>
      </div>
      {/* <div>
        {
          this.state.mapSize !== 1 && <FontAwesomeIcon icon="minus-circle" size={'2x'} onClick={()=> this.decreaseMap()}/>
        }
        <FontAwesomeIcon icon="plus-circle" size={'2x'} onClick={()=> this.increaseMap()}/>
      </div> */}
      <div id="map-views">
        {
          this.state.collapsible? <MapView mapSize={this.state.mapSize} clickTimes={this.state.clickTimes}/>: ""
        }
      </div>
    </div>
  )}
}

function mapStateToProps(state){
  return {
    gender: state.gender,
    countries: state.countries,
    age: state.age,
  }
};

export default connect(mapStateToProps, null)(MapViewCollapsible);



// WEBPACK FOOTER //
// ./src/components/MapViewCollapsible.js